module.exports = __webpack_public_path__ + "img/ai-icon.7683d651.svg";